import { useContext } from 'react'
import { ContractBuilderContext } from '../ContractBuilderContext'

export const useDisableProductsActions = ({ products }) => {
  const { editProductId, isAdditionalInfoEdit } = useContext(ContractBuilderContext)

  const hasNotSelectedProducts = products.some(product => !product.data)

  // forbid products add, delete, edit and etc, if:
  return Boolean(editProductId) || hasNotSelectedProducts || isAdditionalInfoEdit
}
